import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-feed-url-video',
  templateUrl: './feed-url-video.component.html',
  styleUrls: ['./feed-url-video.component.scss']
})
export class FeedUrlVideoComponent implements OnInit, OnChanges {
  @Input() url: string = '';
  safeUrl: SafeResourceUrl = '';
  constructor(private sanitizer: DomSanitizer) {

  }
  ngOnInit(): void {
    this.updateEmbedUrl();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['url'] && changes['url'].currentValue) {
      this.updateEmbedUrl();
    }
  }
  updateEmbedUrl(): void {
    this.safeUrl = this.getEmbedUrl(this.url);
  }
  getEmbedUrl(videoUrl: string): SafeResourceUrl {
    let videoId = '';
    let embedUrl = '';
    if (!videoUrl) return '';
    if (videoUrl.includes('v=')) {
      videoId = videoUrl.split('v=')[1]?.split('&')[0];
      embedUrl = `https://www.youtube.com/embed/${videoId}`;
    } else if (videoUrl.includes('shorts/')) {
      videoId = videoUrl.split('shorts/')[1]?.split('?')[0];
      embedUrl = `https://www.youtube.com/embed/${videoId}`;
    } else if (videoUrl.includes('youtu.be/')) {
      videoId = videoUrl.split('youtu.be/')[1]?.split('?')[0];
      embedUrl = `https://www.youtube.com/embed/${videoId}`;
    } else if (videoUrl.includes('loom.com/share/')) {
      videoId = videoUrl.split('/share/')[1]?.split('?')[0];
      embedUrl = `https://www.loom.com/embed/${videoId}`;
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }
}